var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 1.66667H15V0H13.3333V1.66667H6.66667V0H5V1.66667H2.5C1.83696 1.66667 1.20107 1.93006 0.732233 2.3989C0.263392 2.86774 0 3.50363 0 4.16667L0 20H20V4.16667C20 3.50363 19.7366 2.86774 19.2678 2.3989C18.7989 1.93006 18.163 1.66667 17.5 1.66667ZM1.66667 4.16667C1.66667 3.94565 1.75446 3.73369 1.91074 3.57741C2.06702 3.42113 2.27899 3.33333 2.5 3.33333H17.5C17.721 3.33333 17.933 3.42113 18.0893 3.57741C18.2455 3.73369 18.3333 3.94565 18.3333 4.16667V6.66667H1.66667V4.16667ZM1.66667 18.3333V8.33333H18.3333V18.3333H1.66667Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1667 10.833H12.5V12.4997H14.1667V10.833Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.8334 10.833H9.16675V12.4997H10.8334V10.833Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.49992 10.833H5.83325V12.4997H7.49992V10.833Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.1667 14.167H12.5V15.8337H14.1667V14.167Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.8334 14.167H9.16675V15.8337H10.8334V14.167Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.49992 14.167H5.83325V15.8337H7.49992V14.167Z",
    fill: "#82AFF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderUnselected);
export default __webpack_public_path__ + "static/media/calender_unselected.0d38c77e357bfbfc524709b57a35c71a.svg";
export { ForwardRef as ReactComponent };